export default "__VITE_ASSET__lPK_F0Zy__"